import React from 'react';
import { theme } from 'stitches.config';
import {BorderWaveOutlineRoot} from './BorderWaveOutline.styles'
import { ColorTokens } from 'stitches.config';

interface BorderWaveOutlineProps {
  strokeColor: ColorTokens;
  strokeWidth: number;
  svgHeight: string;
  svgWidth: string;
  invert?: boolean;
  bottom?: boolean;
  path: string;
}

export const BorderWaveOutline: React.FC<BorderWaveOutlineProps> = ({ 
  strokeColor , 
  strokeWidth ,
  svgHeight ,
  svgWidth ,
  invert = false,
  bottom = false,
  path
}) => {
  const colorValue = theme.colors[strokeColor].value;

  return (
    <BorderWaveOutlineRoot invert={invert} bottom={bottom} className="outline">
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 1200 120" 
        preserveAspectRatio="none"
        style={{
          width: svgWidth,
          height: svgHeight,
        }}
      >
        <path 
          d={path}
          fill="none" 
          stroke={colorValue} 
          strokeWidth={strokeWidth} 
          strokeLinecap="round"
        />
      </svg>
    </BorderWaveOutlineRoot>
  );
};